import { lazy } from 'react';

export const AddApplicationsLazy = lazy(() => import('./AddApplications'));
